import type { ReactNode } from 'react';
import { MapPin } from 'lucide-react';
import type { Location } from '~/types';

type AddressSectionProps = {
  title: string;
  address: Location;
  deliveryAddress?: { label: string; text: string } | null;
  mapToggle?: ReactNode;
};

export function AddressSection({
  title,
  address,
  deliveryAddress = null,
  mapToggle,
}: AddressSectionProps) {
  return (
    <div className="bg-neut-bg-alt rounded-lg border border-neut-border p-6 shadow-neut-100">
      <div className="flex items-center gap-2 mb-4">
        <MapPin className="w-5 h-5 text-prim" />
        <h2 className="text-neut-prim font-semibold">{title}</h2>
      </div>
      <div className="p-4 bg-neut-100 rounded-lg">
        {deliveryAddress ? (
          <>
            <p className="text-sm text-neut-prim font-medium mb-1">
              {deliveryAddress.label}
            </p>
            <p
              className="text-xs text-neut-sec"
              data-testid="checkout-delivery-address"
            >
              {deliveryAddress.text}
            </p>
          </>
        ) : (
          <>
            <p className="text-sm text-neut-prim font-medium mb-1">
              {address?.name}
            </p>
            <p className="text-xs text-neut-sec">
              {address?.facility.address.addressLine1}
            </p>
            <p className="text-xs text-neut-sec">
              {[
                address?.facility.address.city,
                address?.facility.address.region,
                address?.facility.address.zipCode,
              ]
                .filter(Boolean)
                .join(' ')}
            </p>
          </>
        )}
        {mapToggle}
      </div>
    </div>
  );
}
